module.exports = __webpack_public_path__ + "img/interested_stroke.58d50076.svg";